import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from 'src/app/models/base-component';
import { GeneralService } from '../../../base/services/general/general.service';
import { PersistenciaService } from '../../../base/services/persistencia/persistencia.service';
import { UsuarioService } from '../../../base/services/usuario/usuario.service';

declare const resaltarPestañaMenu:any;

@Component({
  selector: 'app-horario-profesor',
  templateUrl: './horario-profesor.component.html',
  styleUrls: ['./horario-profesor.component.css']
})
export class HorarioProfesorComponent extends BaseComponent implements OnInit {

  constructor(private router: Router,
    public generalService:GeneralService,
	public persistenciaService:PersistenciaService,
	public modalService: NgbModal,
  public usuarioService:UsuarioService) { 
      super(persistenciaService,modalService,generalService,usuarioService);
    }
  ngOnInit(): void {
    this.init();
		this.buscarAplicacion(this.router.url.substring(1));
  }

  ngAfterViewInit(){
    resaltarPestañaMenu(this.router.url.substring(1)+"1");
    
  }
}
